import React from 'react';

import ExternalLink from 'src/presentation/components/pages/shared/ExternalLink';
import { getAdminURL } from 'src/presentation/components/pages/shared/utils/Utils';

const VoiceDescription = (): JSX.Element => {
  return <EntryPoints />;
};

const EntryPoints = () => (
  <div>
    Configure and manage your voice setup.{' '}
    <ExternalLink
      data-aid="set-up-voice-help-link"
      label="Read Set Up Voice"
      to="https://help.gladly.com/implementation/docs/set-up-voice-ivr"
    />{' '}
    to learn more. Looking to manage your Inboxes?{' '}
    <ExternalLink data-aid="channels-help-link" label="Go to Entry Points" to={getAdminURL('entry-points')} />
  </div>
);

export default VoiceDescription;
